import React from "react";

const RokuIcon = (props) => (
	<svg width="39" height="12" viewBox="0 0 39 12" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M6.08733 3.94574C6.08733 2.84774 5.20398 1.96351 4.12382 1.96351H3.1501V5.91044H4.12382C5.20398 5.91044 6.08733 5.02558 6.08733 3.94574ZM10.5167 11.8141H6.94227L4.10452 7.87596H3.1501V11.8056H0V0H4.51268C7.11421 0 9.23765 1.76909 9.23765 3.94574C9.23765 5.27323 8.4236 6.45893 7.1847 7.18443L10.5167 11.8141Z"
			fill="black"
			fill-opacity="0.45"
		/>
		<path
			d="M14.069 4.65431C13.2371 4.65431 12.5295 5.78507 12.5295 7.1848C12.5295 8.58453 13.2371 9.71673 14.069 9.71673C14.9202 9.71673 15.6267 8.58449 15.6267 7.1848C15.6267 5.78504 14.9202 4.65431 14.069 4.65431ZM18.9177 7.1848C18.9177 9.85883 16.7431 12.0001 14.069 12.0001C11.3958 12.0001 9.2373 9.85883 9.2373 7.1848C9.2373 4.51279 11.3958 2.37035 14.069 2.37035C16.7431 2.37035 18.9177 4.51279 18.9177 7.1848ZM26.31 2.56615L22.6812 6.19433V2.55416H19.5317V11.8056H22.6812V8.05287L26.4697 11.8056H30.4338L25.6196 6.99082L29.6071 3.00477V8.49497C29.6071 10.3178 30.7033 12 33.464 12C34.7745 12 35.9772 11.2567 36.5617 10.5842L37.9778 11.8056H38.6501V2.56615H35.5005V8.5482C35.1459 9.16723 34.6517 9.55644 33.888 9.55644C33.1131 9.55644 32.7575 9.09705 32.7575 7.62768V2.56615H26.31Z"
			fill="black"
			fill-opacity="0.45"
		/>
	</svg>
);

export default RokuIcon;

